import React from 'react'
import { Redirect } from 'react-router-dom'

function NewThread () {
  return (
    <Redirect to='/denali-ai/new' />
  )
}

export default NewThread
